/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown>, max: NonNullable<unknown> }} Plan_Gallery_Invalid_TitleInputs */

const en_us2_plan_gallery_invalid_title = /** @type {(inputs: Plan_Gallery_Invalid_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The name takes ${i?.min} to ${i?.max} characters.`)
};

const pt_br2_plan_gallery_invalid_title = /** @type {(inputs: Plan_Gallery_Invalid_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O nome precisa ter de ${i?.min} a ${i?.max} caracteres.`)
};

const pt_pt2_plan_gallery_invalid_title = /** @type {(inputs: Plan_Gallery_Invalid_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O nome precisa ter de ${i?.min} a ${i?.max} caracteres.`)
};

/** @type {(inputs: Plan_Gallery_Invalid_TitleInputs) => LocalizedString} */
const es_419_plan_gallery_invalid_title = en_us2_plan_gallery_invalid_title;

/** @type {(inputs: Plan_Gallery_Invalid_TitleInputs) => LocalizedString} */
const fr_fr2_plan_gallery_invalid_title = en_us2_plan_gallery_invalid_title;

/** @type {(inputs: Plan_Gallery_Invalid_TitleInputs) => LocalizedString} */
const de_de2_plan_gallery_invalid_title = en_us2_plan_gallery_invalid_title;

/** @type {(inputs: Plan_Gallery_Invalid_TitleInputs) => LocalizedString} */
const it_it2_plan_gallery_invalid_title = en_us2_plan_gallery_invalid_title;

/**
* | output |
* | --- |
* | "The name takes {min} to {max} characters." |
*
* @param {Plan_Gallery_Invalid_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_gallery_invalid_title = /** @type {((inputs: Plan_Gallery_Invalid_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gallery_Invalid_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_gallery_invalid_title(inputs)
	if (locale === "es-419") return es_419_plan_gallery_invalid_title(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_gallery_invalid_title(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_gallery_invalid_title(inputs)
	if (locale === "de-DE") return de_de2_plan_gallery_invalid_title(inputs)
	if (locale === "it-IT") return it_it2_plan_gallery_invalid_title(inputs)
	return en_us2_plan_gallery_invalid_title(inputs)
});
export { plan_gallery_invalid_title as "plan_gallery.invalid_title" }